import React, { FC } from 'react'
import './checkbox.css'

// UTILITIES
import { flatten } from '@utils/string-helper'


interface Props extends Omit<React.HTMLAttributes<HTMLLabelElement>, 'onChange'> {
    checked?: boolean
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
    disabled?: boolean
    name?: React.InputHTMLAttributes<HTMLInputElement>['name']
    value?: React.InputHTMLAttributes<HTMLInputElement>['value']
}

// ToDo: Replace Label with div element. Label nesting is a bad practice, but custom checkboxes usually use a label element to handle native events.
// ToDo: Handle keyboard inputs. Tab into and "space" toggles a checkbox by default
const Checkbox: FC<Props> = (props) => {
    const { className: classProps, tabIndex = 0, children, name, value, checked, onChange, disabled, ...labelProps } = props
    const className = flatten({ disabled }, "checkbox", classProps)

    return (
        <label className={className} tabIndex={tabIndex} {...labelProps}>
            <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} name={name} value={value} />
            <span className="checkmark" />
            {children}
        </label>
    )
}

export default Checkbox